/*
 * REMIND CUSTOM: sticky-buy-visibility
 * ------------------------------------------------------------------
 * ROAR 6.0.0's <product-sticky-form> only reveals the sticky Add-to-Cart in the
 * scroll window between the buy button and `.footer-group`
 * (show when: buy-form scrolled above the top AND footer not yet visible).
 * On SHORT product pages the footer sits less than one viewport below the buy
 * button, so that window is empty and the bar never appears.
 *
 * This add-on reveals the bar whenever the buy-form has scrolled above the top of
 * the viewport (the footer constraint is dropped), so it works on every product
 * regardless of page length. It toggles a `.remind-sticky-show` class; the actual
 * show/hide is done by a scoped `!important` rule in remind-custom.css that
 * overrides ROAR's inline opacity/visibility. ROAR's theme.js is left untouched.
 * ------------------------------------------------------------------
 */
(function () {
  function init(sf) {
    if (sf.__remindStickyInit) return;
    var card = sf.firstElementChild;
    var form = sf.scopeFrom || document.getElementById(sf.getAttribute('form'));
    if (!card || !form) return;
    sf.__remindStickyInit = true;

    var ticking = false;
    function apply() {
      ticking = false;
      // reveal once the buy-form's bottom edge is above the top of the viewport
      card.classList.toggle('remind-sticky-show', form.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  function boot() {
    document.querySelectorAll('product-sticky-form').forEach(init);
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('product-sticky-form').then(boot);
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
